import React, { Fragment, useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { IoArrowBackCircleOutline } from 'react-icons/io5';
import { RiFileList2Line } from 'react-icons/ri';

import BarraProgreso from '../../layout/BarraProgreso';
import clienteAxios from '../../../config/axios';
import { CRMContext } from '../../context/CRMContext';

import CertificadoParteUnoB from './CertificadoParteUnoB';
import CertificadoParteDosB from './CertificadoParteDosB';
import CertificadoParteTresB from './CertificadoParteTresB';

import Prueba from './Prueba';
import { PDFViewer } from '@react-pdf/renderer';

import CertificadoDos from './CertificadoDos';

function FormCertificadoB() {

    const { id } = useParams();

    const [ herramienta, guardarHerramienta ] = useState({});

    const [ primero, guardarPrimero ] = useState({});
    const [ segundo, guardarSegundo ] = useState({});
    const [ tercero, guardarTercero ] = useState({});

    const [ certificados, guardarCertificados ] = useState(true);

    // usar context
    const [auth, guardarAuth] = useContext(CRMContext);

    let navigate = useNavigate();

    // pagina
    const [page, setPage] = useState("pageone");

    const nextPage = (page) => {
        setPage(page);
    };

    const nextPageNumber = (pageNumber) => {
        switch (pageNumber) {
        case "1":
            setPage("pageone");
            break;
        case "2":
            setPage("pagetwo");
            break;
        case "3":
            setPage("pagethree");
            break;
        case "4":
            alert("Ooops! Seems like you did not fill the form.");
            break;
        default:
            setPage("1");
        }
    };

    const guardarDatosPrimero = (datos) => {
        guardarPrimero(datos);
    }

    const guardarDatosSegundo = (datos) => {
        guardarSegundo(datos);
    }

    const guardarCheckCertificado = (check) => {
        guardarCertificados(check);
    }

    const guardarDatosTercero = (datos) => {

        const observaciones = datos.observaciones.split("\n");
        const nota = datos.nota.split("\n");

        guardarTercero({
            observaciones,
            nota,
            rojo: datos.rojo,
            operativo: datos.operativo
        });    

        document.querySelector(".card").style.display = "none";
        document.querySelector("#usuarioEmpresa").style.display = "block";    
    }

    const consultarAPI = async () => {
        try {
            const res = await clienteAxios.get(`ih/ingreso/${id}`,{
                headers: {
                    Authorization: `Bearer ${auth.token}`
                }
            });
            
            guardarHerramienta(res.data)

        } catch (error) {
            console.log(error)
        }
    }

    const cargarDatosCertificado = async () => {
        try {
            const res = await clienteAxios.get(`certificado-calibracion/${id}`,{
                headers: {
                    Authorization: `Bearer ${auth.token}`
                }
            });
            
            if(res.data) {
                const datos = res.data;

                console.log(datos);
                // Cargar datos del certificado (primero)
                if(datos.fechaEmicion || datos.patron || datos.unidad) {
                    guardarPrimero({
                        fechaEmicion: datos.fechaEmicion || '',
                        fechaComparacion: datos.fechaComparacion || '',
                        unidad: datos.unidad || '',
                        rango: datos.rango || '',
                        resolucion: datos.resolucion || '',
                        fechaCalibracion: datos.fechaCalibracion || '',
                        proximaMantencion: datos.proximaMantencion || '',
                        patron: datos.patron || 'CERTIFICADO N° SC-3438/25 REGISTRO NACIONAL N° 14122',
                        numeroSeriePatron: datos.numeroSeriePatron || '0905801',
                        marcaPatron: datos.marcaPatron || 'SNAP-ON',
                        modeloPatron: datos.modeloPatron || 'TTC400B',
                        unidadPatron: datos.unidadPatron || 'LBRS/PIE',
                        rangoPatron: datos.rangoPatron || '200-2000',
                        resolucionPatron: datos.resolucionPatron || '0.1',
                        fechaCalibracionPatron: datos.fechaCalibracionPatron || "2022-12-15"
                    });
                }
                
                // Cargar datos de comparación (segundo)
                if(datos.llegadaFinal || datos.comparacionFinal || datos.entregaFinal) {
                    guardarSegundo({
                        llegadaFinal: Array.isArray(datos.llegadaFinal) ? datos.llegadaFinal.map(item => ({
                            name: item.name,
                            numero: parseFloat(item.numero),
                            usado: Boolean(item.usado)
                        })) : [],
                        comparacionFinal: Array.isArray(datos.comparacionFinal) ? datos.comparacionFinal.map(item => ({
                            name: item.name,
                            numero: parseFloat(item.numero),
                            usado: Boolean(item.usado)
                        })) : [],
                        entregaFinal: Array.isArray(datos.entregaFinal) ? datos.entregaFinal.map(item => ({
                            name: item.name,
                            numero: parseFloat(item.numero),
                            usado: Boolean(item.usado)
                        })) : []
                    });
                }
                
                // Cargar datos de observaciones (tercero)
                if(datos.observaciones || datos.nota || datos.operativo !== undefined) {
                    guardarTercero({
                        observaciones: Array.isArray(datos.observaciones) ? datos.observaciones : [],
                        nota: Array.isArray(datos.nota) ? datos.nota : [],
                        rojo: datos.rojo || '',
                        operativo: datos.operativo !== undefined ? Boolean(datos.operativo) : false
                    });
                }
                
                // Cargar configuración de certificados
                if(datos.certificados !== undefined) {
                    guardarCertificados(Boolean(datos.certificados));
                }
            }

        } catch (error) {
            // Si no hay datos guardados, simplemente continuar sin error
            console.log('No hay datos previos del certificado o error al cargar:', error)
        }
    }

    useEffect(() => {
        if(auth.token !== '' && (auth.tipo === 1 || auth.tipo === 2 || auth.tipo === 4 || auth.tipo === 3) ) {            
            consultarAPI();
            cargarDatosCertificado();
        } else {
            navigate('/login', {replace: true});
        } 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
        <Fragment>
            <div className="card contenedor">
                <div className="card-header">
                    <RiFileList2Line size={50} color={"#333333"}/>
                    <h1>Generar Certificado de Calibración</h1>
                </div>
                <div className="card-body">

                    <div className='top-left'>
                        <Link to={'/ingresos'} className="btn-new btn-error"><IoArrowBackCircleOutline size={25}/> Cancelar Certificado</Link>
                    </div>

                    <h2 className='card-body-subtitle'> Llene todos los campos según corresponda: </h2>

                    <BarraProgreso page={page} onPageNumberClick={nextPageNumber} />
                    {
                        {
                            pageone: <CertificadoParteUnoB onButtonClick={nextPage} guardarDatosPrimero={guardarDatosPrimero} id={id} primero={primero} />,
                            pagetwo: <CertificadoParteDosB onButtonClick={nextPage} guardarDatosSegundo={guardarDatosSegundo} rango={primero.rango} unidad={primero.unidad} segundo={segundo} />,
                            pagethree: <CertificadoParteTresB onButtonClick={nextPage} guardarDatosTercero={guardarDatosTercero} tercero={tercero} checkCertificados={certificados} guardarCheckCertificado={guardarCheckCertificado} />
                        }[page]
                    }
                </div>
            </div>

            <CertificadoDos
                primero={primero}
                segundo={segundo}
                tercero={tercero}
                herramienta={herramienta}
                certificados={certificados}
            />

            {/* <PDFViewer>
                <Prueba
                    primero={primero}
                    segundo={segundo}
                    tercero={tercero}
                    herramienta={herramienta}
                />
            </PDFViewer> */}
        
        </Fragment>
    )
}

export default FormCertificadoB;